import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a logging function

const sendInvite = async (
  user_id,
  senderEntreprise,
  receiverEmail,
  oid,
  token,
  prefix
) => {
  const url = prefix + `organisations/${oid}/invite `;

  // Define the request body
  const body = {
    user_id: user_id,
    sender_entreprise: senderEntreprise,
    url: "https://web.hexagone.expert/login",
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return null;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return null;
    }

    const org_id = userSnapshot.get("org_id");

    // Make the POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const responseData = await response.json(); // Convert the response to JSON
    let end = new Date();
    let elapsed = end - start;
    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body
      JSON.stringify(response.data),
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
    } else {
      console.error(`Failed to send invite: ${response.status}`);
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
  }
};

export default sendInvite;
